import React, { useState, useEffect, useCallback } from 'react'
import agrim from "../../Assets/images/agrim.png"
import Base from '../../Components/Layout/Base'
import { useLocation } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { applyJob, fetchSingleJob, withdrawJob } from '../../Redux/Actions/jobBoard'
import back from "../../Assets/images/back.svg"
import { useNavigate, useSearchParams } from 'react-router-dom'
import useModalManager from '../../utils/ModalManager'
import { authenticate, validate } from '../../Redux/Actions/auth'
import OTPModal from '../../Components/modals/OTP'
import EmailModal from '../../Components/modals/Login'
import { fetchNormalSubmission, getProfile, introVideoDetails } from '../../Redux/Actions/ProfileSteps'

// const MODAL_TYPES = {
//   EMAIL: 'email',
//   OTP: 'otp',
// };

const JobCardDetail = ({ nologo, screening, withdrawApplication, item }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch()
  const [searchParams] = useSearchParams();
  const kids = useSelector(state => state.dashboard.kids);
  const [data, setData] = useState(location?.state?.data)
  const resumeData = useSelector(s => s.ProfileSteps.submissionData);
  const introdata = useSelector(s => s.ProfileSteps.introData);
  const jobDetails = useSelector(s => s.jobBoard.jobDetails);
  const profileData = useSelector(s => s.ProfileSteps.profileData);
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  const [applicationStatus, setApplicationStatus] = useState(data?.application_status);



  // const {
  //   modalRefs,
  //   userEmail,
  //   setUserEmail,
  //   isLoading,
  //   setIsLoading,
  //   openModal,
  //   closeAllModals
  // } = useModalManager();
  // const showotp = useSelector((state) => state.auth.showotp);

  // useEffect(() => {
  //   const jobId = searchParams.get('id');
  //   if (!isAuthenticated) {
  //     jobId ? navigate('/home', { state: { path: jobId } }) : navigate('/')
  //     //  const fetch =  handleJobSeekersClick()
  //   }
  // }, [isAuthenticated]);

  useEffect(() => {
    const jobId = searchParams.get('id');

    if (!isAuthenticated) {
      jobId ? navigate('/home', { state: { path: jobId } }) : navigate('/')
    }
    if (isAuthenticated && jobId) {
      // closeAllModals();

      dispatch(fetchSingleJob({ job_unique_id: jobId }));
      kids && kids[0]?.id && dispatch(getProfile(kids[0]?.id))
      kids && kids[0]?.id && dispatch(fetchNormalSubmission({ kid_id: kids[0]?.id, "activity_id": 1172 }))
      kids && kids[0]?.id && dispatch(introVideoDetails({ kid_id: kids[0]?.id }))
    }
  }, [isAuthenticated]);
  useEffect(() => {
    if (location?.state?.data) {  
      setData(location?.state?.data);
    } else if (jobDetails) {
      setData(jobDetails.data || null);
      setApplicationStatus(jobDetails?.data?.application_status)
    }
  }, [location?.state?.data, jobDetails]);

console.log(jobDetails?.data,data,"job details data")
  // Check if profile is complete
  const isProfileComplete =
    resumeData?.submission?.[0]?.fileUrlDtoList?.[0]?.fileUrl &&
    introdata?.length > 0 &&
    profileData?.user_name;

  const handleApply = () => {
    setApplicationStatus("APPLICATION_SENT");
    dispatch(applyJob({ job_id: data?.job_id, kid_id: kids[0]?.id }))
  }

  const handleApplyClick = () => {
    if (isProfileComplete) {
      // Directly apply if profile is complete
      handleApply();
    }
    // If not complete, modal will open via data-bs-toggle
  }

  const handleWithdraw = () => {
    setApplicationStatus("WITHDRAWN");
    dispatch(withdrawJob({ job_id: data?.job_id, kid_id: kids[0]?.id }))
  }

  const modalId = `withdrawModal_${data?.job_id}`;
  const applyModalId = `applyModal_${data?.job_id}`;

  const handleBack = () => {
    if (searchParams.has('internship')) {
      navigate('/job-board?internship', { replace: true });
    } else if (searchParams.has('fulltime')) {
      navigate('/job-board?fulltime', { replace: true });
    } else {
      // Default to fulltime if no params
      navigate('/job-board?fulltime', { replace: true });
    }
  }
  return (
    <Base>
      <section className='job-card-detail-main pt-5 section-bottom-padding'>
        {data ? (
        <div className="container-fluid px-lg-5">
          <div className='d-flex align-items-center mt-4 mb-3'>
            {/* <button className='border-0 bg-transparent ps-0 me-1'>
              <img src={back} alt="back" className='w-75' />
            </button> */}
            <nav aria-label="breadcrumb" className='cstm-breadcrumb'>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item" type="button" onClick={handleBack}>Jobs</li>
                <li className="breadcrumb-item active" aria-current="page">{data?.company_name}</li>
              </ol>
            </nav>
          </div>
          <div class="job-card h-auto">
            <div class="job-card-body pt-4">
              <img src={data?.company_logo_url} alt='' className='job-card-logo-detail' />
              <h2 className='job-card-title my-3'>{data?.company_name}</h2>
              <ul class="job-card-feature-list">
                <li class="fw-bold">
                  <img src="./svg/sdm.svg" alt="" className='d-inline-block' />
                  {data?.job_title}
                </li>
                <li><img src="./svg/soe.svg" alt="" className='d-inline-block' />{data?.job_department}</li>
                <li><img src="./svg/location.svg" alt="" className='d-inline-block' />{data?.job_location}</li>
              </ul>
              <div className='d-flex flex-column flex-lg-row justify-content-between'>
                <div class="card-tags-main d-flex flex-wrap">
                  {data?.work_mode && <div class="card-tags mb-lg-0 me-2">{data?.work_mode}</div>}
                  {data?.job_type && <div class="card-tags mb-lg-0 me-2">Type : {data?.job_type == "FULLTIME" ? "Full Time" : data?.job_type == "INTERNSHIPSIXMONTHS" ? "Internship - 6 months" : "Internship - 2 months"}</div>}
                  {data?.application_last_date && <div class="card-tags mb-lg-0 me-2">Apply by : {new Date(data?.application_last_date).toLocaleDateString('en-GB', {
                    day: 'numeric',
                    month: 'short',
                    year: 'numeric'
                  })}</div>}
                </div>
                {applicationStatus === "APPLICATION_SENT" ? (
                  <button
                    className='default-btn blue-border-btn'
                    data-bs-toggle="modal"
                    data-bs-target={`#${modalId}`}
                  >
                    Withdraw Application
                  </button>
                ) : (
                  <button
                    className={`default-btn ${screening}`}
                    {...(!isProfileComplete && {
                      'data-bs-toggle': 'modal',
                      'data-bs-target': `#${applyModalId}`
                    })}
                    onClick={handleApplyClick}
                  >
                    Apply Now
                  </button>
                )}
              </div>
            </div>
          </div>
          <div className='about-job-detail mt-4'>
            <h2 className='job-card-title mb-4'>About the job</h2>
            <ul class="job-card-feature-list">
              {data?.job_department && <li className="fw-bold border-bottom pb-3">
                <img src="./svg/department.svg" alt="" className='d-inline-block' />
                <span className='fw-normal'>Department : </span> {data?.job_department}
              </li>}
              {data?.ctc && <li class="fw-bold border-bottom pb-3"><img src="./svg/ctc.svg" alt="" className='d-inline-block' />
                <span className='fw-normal'>{`${data?.job_type == "FULLTIME" ? "CTC" : "Stipend"}`} : </span> ₹{(data?.ctc || 0).toLocaleString('en-IN')}
              </li>}
              {data?.number_openings && <li className="fw-bold border-bottom pb-3">
                <img src="./svg/positions.svg" alt="" className='d-inline-block' />
                <span className='fw-normal'>No of positions : </span> {data?.number_openings}
              </li>}
              {data?.job_description?.about_us?.length > 0 && <li className="fw-bold  pb-3 align-items-start">
                <img src="./svg/about-us.svg" alt="" className='d-inline-block' />
                <span className='fw-normal'>About Us :
                  <ul className='circle-list mt-2'>
                    {data?.job_description?.about_us?.length > 0 ? data?.job_description?.about_us?.map((para, index) => (
                      <li key={index}>{para}</li>
                    )) : null}
                    {/* - <a href="">Click here</a> */}
                  </ul>
                </span>
              </li>}
              {data?.job_description?.role_overview?.length > 0 && <li className="fw-bold pb-3 align-items-start">
                <img src="./svg/job-description.svg" alt="" className='d-inline-block' />
                <span className='fw-normal'>Role Overview :
                  <ul className='circle-list mt-2'>
                    {/* {data?.job_description?.role_overview?.[0]} */}
                    {data?.job_description?.role_overview?.length > 0 ? data?.job_description?.role_overview?.map((para, index) => (
                      <li key={index}>{para}</li>
                    )) : null}
                  </ul>
                </span>
              </li>}
              {data?.job_description?.job_description?.length > 0 && <li className="fw-bold pb-3 align-items-start">
                <img src="./svg/job-description.svg" alt="" className='d-inline-block' />
                <span className='fw-normal'>Job Description :
                  <ul className='circle-list mt-2'>
                    {/* {data?.job_description?.role_overview?.[0]} */}
                    {data?.job_description?.job_description?.length > 0 ? data?.job_description?.job_description?.map((para, index) => (
                      <li key={index}>{para}</li>
                    )) : null}
                  </ul>
                </span>
              </li>}
              {data?.job_description?.key_responsibilities?.length > 0 && <li className="fw-bold pb-3 align-items-start">
                <img src="./svg/key.svg" alt="" className='d-inline-block' />
                <span className='fw-normal'>Key Responsibilities :
                  <ul className='circle-list mt-2'>
                    {data?.job_description?.key_responsibilities?.map((responsibility, index) => (
                      <li key={index}>{responsibility}</li>
                    ))}
                  </ul>
                </span>
              </li>}
              {data?.job_description?.requirements?.length > 0 && <li className="fw-bold pb-3 align-items-start">
                <img src="./svg/requirement.svg" alt="" className='d-inline-block' />
                <span className='fw-normal'>Requirements :
                  <ul className='circle-list mt-2'>
                    {data?.job_description?.requirements?.map((requirement, index) => (
                      <li key={index}>{requirement}</li>
                    ))}
                  </ul>
                </span>
              </li>}
              {data?.job_description?.why_join_us?.length > 0 && <li className="fw-bold pb-3 align-items-start">
                <img src="./svg/join-us.svg" alt="" className='d-inline-block' />
                <span className='fw-normal'>Why join Us? :
                  <ul className='circle-list mt-2'>
                    {data?.job_description?.why_join_us?.map((reason, index) => (
                      <li key={index}>{reason}</li>
                    ))}
                  </ul>
                </span>
              </li>}
              {data?.job_description?.compensation_structure?.length > 0 && <li className="fw-bold align-items-start">
                <img src="./svg/ctc.svg" alt="" className='d-inline-block' />
                <span className='fw-normal'>Compensation Structure :
                  <ul className='circle-list mt-2'>
                    {data?.job_description?.compensation_structure?.map((responsibility, index) => (
                      <li key={index}>{responsibility}</li>
                    ))}
                  </ul>
                </span>
              </li>}
            </ul>
          </div>
        </div> ) : (
            <div className="text-center mb-5 p-4">
<div>
            <h3 className='no-data-title'>Not Found</h3>
          <span style={{fontSize:"12px"}}>No Job Detail found for the provided details </span>
          <div type="button" className='pt-2 text-primary' onClick={() => handleBack()} style={{fontSize:"12px"}}>Explore Jobs </div>
</div>
          <img  src={`images/empty-data-vector.svg`}  alt='no data img' className='' />
        </div>
        )}

        {/* Withdraw Modal */}
        <div
          className="modal fade common-modal"
          id={modalId}
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          tabIndex="-1"
          aria-labelledby={`${modalId}Label`}
          aria-hidden="true"
        >
          <div className="modal-dialog modal-lg">
            <div className="modal-content border-0">
              <div className="modal-body text-center px-3 px-lg-5">
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
                <h2 className='popup-title mb-3'>Withdraw Application</h2>
                <p className='mb-4'>
                  Are you sure you want to withdraw your application for {data?.job_title} at {data?.company_name}?
                </p>
                <button
                  type="button"
                  onClick={handleWithdraw}
                  data-bs-dismiss="modal"
                  className="default-btn w-100 mb-3"
                >
                  Yes, Withdraw
                </button>
                <button
                  type="button"
                  className="default-btn blue-border-btn w-100"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Apply Modal */}
        <div
          className="modal fade common-modal"
          id={applyModalId}
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          tabIndex="-1"
          aria-labelledby={`${applyModalId}Label`}
          aria-hidden="true"
        >
          <div className="modal-dialog modal-lg">
            <div className="modal-content border-0">
              <div className="modal-body text-center px-3 px-lg-5">
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
                <h2 className='popup-title mb-3'>Update your Profile</h2>
                <p className='mb-4'>
                  Upload your <strong>resume</strong> and add a 1-2 minute <strong>introduction video</strong> to unlock job applications and increase your chances of selection.
                </p>
                <button
                  type="button"
                  onClick={() => navigate("/profile")}
                  data-bs-dismiss="modal"
                  className="default-btn w-100 mb-3"
                >
                  Update Profile
                </button>
                <button
                  type="button"
                  className="default-btn blue-border-btn w-100"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* <EmailModal
              modalRef={modalRefs[MODAL_TYPES.EMAIL]}
              onSendOTP={handleSendOTP}
              onClose={closeAllModals}
              isLoading={isLoading}
            />
      
            <OTPModal
              modalRef={modalRefs[MODAL_TYPES.OTP]}
              userEmail={userEmail}
              onVerifyOTP={handleVerifyOTP}
              onChangeEmail={handleChangeEmail}
              onClose={handleClose}
              isLoading={isLoading}
            /> */}
      </section>
    </Base>
  )
}


export default JobCardDetail
